import { render, staticRenderFns } from "./CessionsList.vue?vue&type=template&id=d9ef5aa4&"
import script from "./CessionsList.vue?vue&type=script&lang=js&"
export * from "./CessionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CessionsList.vue"
export default component.exports